export default {
  inputValue: {},
  vessels: [],
  pictures: [],
  freeFiles: [],
};
